import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import * as _ from 'lodash';
import { AlertMessageModel, results } from 'src/app/common/models/common.model';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';
import { SnapshotService } from '../Services/snapshot.service';

@Component({
  selector: 'app-selection-summary-view',
  templateUrl: './selection-summary-view.component.html',
  styleUrls: ['./selection-summary-view.component.css']
})
export class SelectionSummaryViewComponent {

  @Output() isSavePopUpVisible = new EventEmitter<any>();
  @Output() SaveSelectionClick = new EventEmitter<any>();
  @Input() Header : string = '';
  @Input() isSelectionSummaryClick : boolean = false;
  @Input() isSaveSelectionClick: boolean = false;
  SaveSelection: string = '';
  selectionSummary : String = '';
  headerText : String = "" ;
  
  // New structured data model
  titleSection: {key: string, value: string}[] = [];
  entryPoints: {key: string, value: string}[] = [];
  selections: {key: string, value: string}[] = [];
  
  constructor(private _alertService: AlertMessageService, public _configService: SnapshotService) {}
  
  ngOnInit() { 
    this.selectionSummary = this._configService.selectionSummaryTextTitle;
    this.headerText = this.Header;
    this.GenerateSelectionSummary();
    this.AddBrandToSelectionSummary();
  }

  GenerateSelectionSummary() {
    // Clear existing data
    this.titleSection = [];
    this.entryPoints = [];
    this.selections = [];
    
    let selectionSummaryArray = this.selectionSummary.split("||");
    
    // Process the selectionSummary string
    for (let i = 0; i < selectionSummaryArray.length; i++) {
      let section = selectionSummaryArray[i].trim();
      
      if (section.startsWith("Compare Across:")) {
        // Handle the title section
        const titleContent = section.replace("Compare Across:", "").trim();
        
        // Parse the title content (e.g., "Single Brand: Brand Scorecard")
        const titleParts = titleContent.split(":");
        if (titleParts.length > 1) {
          this.titleSection.push({
            key: titleParts[0].trim(),
            value: titleParts.slice(1).join(":").trim()
          });
        } else {
          // In case there's no colon in the title
          this.titleSection.push({
            key: "",
            value: titleContent
          });
        }
      } 
      else if (section.startsWith("Entry Point:")) {
        // Handle Entry Points section
        const entryPointContent = section.replace("Entry Point:", "").trim();
        const entryPointItems = entryPointContent.split(";");
        
        for (let item of entryPointItems) {
          item = item.trim();
          if (item) {
            const itemParts = item.split(":");
            if (itemParts.length > 1) {
              this.entryPoints.push({
                key: itemParts[0].trim(),
                value: itemParts.slice(1).join(":").trim()
              });
            }
          }
        }
      }
      else if (section.startsWith("Selections:")) {
        // Handle Selections section
        let selectionsText = section.replace("Selections:", "").trim();
        let selectionItems = selectionsText.split("|");
        
        for (let item of selectionItems) {
          item = item.trim();
          if (item) {
            let itemParts = item.split(":");
            if (itemParts.length > 1) {
              let key = itemParts[0].trim();
              let value = itemParts.slice(1).join(":").trim();
              
              this.selections.push({
                key: key,
                value: value
              });
            }
          }
        }
      }
      else if (section) {
        // Handle other sections (Significance, Base, Weight)
        let sectionParts = section.split(":");
        if (sectionParts.length > 1) {
          let key = sectionParts[0].trim();
          let value = sectionParts.slice(1).join(":").trim();
          
          this.selections.push({
            key: key,
            value: value
          });
        }
      }
    }
  }

  AddBrandToSelectionSummary() {
    // Get the brand value from the finalLeftPanelSubmitObject
    const brandValue = this._configService?.finalLeftPanelSubmitObject?.previewData
      ?.Audiencebrand?.[0]?.option;
    
    if (brandValue) {
      // Remove the pipe and use the last part
      const rawBrandName = brandValue.split('|').pop() ?? brandValue;
      const brandName = `${rawBrandName}`;
      
      // Add brand to the selections array
      this.selections.push({
        key: 'Brand',
        value: brandName
      });
    }
  }

  OnCloseClick(){
    this.isSaveSelectionClick = false;
    this.SaveSelection = '';
    this.isSavePopUpVisible.emit({
      isClose: false,
    });
  }

  onSaveBtnClick(){
    if (this.SaveSelection == '') {
      this.errorPopup('Selection name cannot be empty.');
    } else {
      this.SaveSelectionClick.emit({
        isValidationPass: true,
        selectionName: this.SaveSelection,
        isShareSelection: false, //this is for save selection
        selectionType: 'userDefined', //only user defined can be saved
        Audiencebrand: this._configService.finalLeftPanelSubmitObject?.previewData?.Audiencebrand || null
      });
    }
  }
  
  errorPopup(message: string, headerTxt: string = 'Error'): void {
    const alertObj: AlertMessageModel = {
      header: headerTxt,
      message: message,
      show: true,
    };
    this._alertService.showAlert(alertObj);
  }

  onKeyDown(event: KeyboardEvent): void {
    // Get the pressed key
    const pressedKey = event.key;

    // Allow alphanumeric characters, space, and backspace; prevent other keys

    //onst isValidKey = /^[A-Za-z0-9\s\-_]+$/.test(pressedKey);

    //const isValidKey = /^[^\s@]+$/.test(pressedKey);
    const isValidKey = /^[^\@]+$/.test(pressedKey) || pressedKey === ' ';

    if (!isValidKey) {
      event.preventDefault();
    }
  }
}
